import styled from "styled-components";
import { TextNodeType } from "../../CommonLandingMweb.types";
import { Container, Icon, Left, Stats } from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

interface PersuasionProps {
  persuasion?: {
    title?: TextNodeType;
    subtitle?: TextNodeType;
  };
}

export const Persuasion = ({ persuasion }: PersuasionProps) => {
  if (!persuasion) return null;

  return (
    <Container>
      <Left>
        <Stats>
          <FormattedText value={persuasion.title} />
        </Stats>
      </Left>
      {persuasion.subtitle ? (
        <Stats>
          <FormattedText value={persuasion.subtitle} />
        </Stats>
      ) : null}
    </Container>
  );
};

